// Quotation Rejected Stage  Btn related codes goes here

// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Button } from "@revvsales/components";

// Components Imports
// import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
// import UploadRevision from "./UploadRevision";
// import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
import SendForReview from "../../QuotationTopbar/QuotationTopbarBtns/SendForReview";
// import { USER_ROLES } from "../../../constants/roleList";
import { GlobalUtils } from "../../../utils";
import QuotationFillerBottomBanner from "../../QuotationTopbar/QuotationBottomBar/QuotationFillerBottomBanner";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;
class QuotationSentOwnerBtns extends Component {
  state = {
    // showReferralPopup: false,
  };

  _acceptanceStatusBand = () => {
    const { acceptorsList, docRecipientList } = this.props;
    let bandStatus = null;
    const signerList = [];
    docRecipientList.map(item =>
      item.recipient_type === "SIGNER" ? signerList.push(item) : null,
    );
    if (acceptorsList && acceptorsList.length > 0) {
      bandStatus = (
        <div className="doc-status-warning-band">
          <span className="doc-statusband-check">
            <FontAwesomeIcon icon={["far", "check"]} />
          </span>

          <div>Document sent for acceptance</div>
        </div>
      );
    } else if (signerList && signerList.length > 0) {
      bandStatus = (
        <div className="doc-status-warning-band">
          <span className="doc-esign-statusband-check">
            <FontAwesomeIcon icon={["far", "signature"]} />
          </span>

          <div>Document sent for eSignature</div>
        </div>
      );
    }
    return bandStatus;
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    // let popupSpace = null;

    // if (this.state.showReferralPopup) {
    //   popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    // }

    const { docStage, docRecipientList, showSubmitAndDeclineBtn } = this.props;
    return (
      <Fragment>
        {/**
        {popupSpace}
        <Fragment>
          <div>
            <Tooltip placement="bottom" overlay="Refer and get benefits!">
              <span
                className="referral-wrapper"
                onClick={() =>
                  this._toggleNavbarPopup("showReferralPopup", true)
                }
                onKeyPress={() => {}}
                tabIndex="0"
                role="button">
                <span aria-label="referral-gift-wrapper" role="img">
                  🎁
                </span>
              </span>
            </Tooltip>
          </div>
          {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
            <div>
              <Tooltip placement="bottom" overlay="Invite team members to Revv">
                <span
                  className="user-role-wrapper"
                  onClick={() =>
                    this.props.togglePopUp("showTeammatePopup", true)
                  }
                  onKeyPress={() => {}}
                  tabIndex="0"
                  role="button">
                  <FontAwesomeIcon icon={["fas", "user-plus"]} />
                </span>
              </Tooltip>
            </div>
          )}
          <div className="user-invite-line" />
        </Fragment>
        {!this.props.showForm ? (
          <Tooltip
            placement="bottom"
            align={{
              offset: [0, 4],
            }}
            overlay="Document already sent for signature/acceptance.">
            <div>
              <Button
                className="revv-btn-disabled-esign"
                id={"signerDetails".replace(/ +/g, "-").toLowerCase()}>
                <FontAwesomeIcon
                  icon={["far", "signature"]}
                  className="documentrecipientlist-role-icon"
                />
                &nbsp; eSign
              </Button>
            </div>
          </Tooltip>
        ) : null}
         */}
        <SendForReview {...this.props} />
        {/* <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp(
              "showAddRecipientsPopup",
              true,
              "forReviewer",
            )
          }
          id={"Send for review".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Send for review
        </Button> */}
        {/* Sent for filling : submit decline button */}
        {docStage === "SENT_FOR_FILLING" &&
          docRecipientList &&
          docRecipientList.some(
            item =>
              item.user &&
              item.user.id === CURRENT_USER.id &&
              item.recipient_type === "FILLER",
          ) &&
          showSubmitAndDeclineBtn && (
            <QuotationFillerBottomBanner {...this.props} />
          )}
        {/* <ExportDocumentBtn docStatus={this.props.docStatus} />
        <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp("showConfirmMoveToDraftPopup", true)
          }
          id={"EditBtnWithRbac".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Edit document
        </Button> */}
        {/* <UploadRevision {...this.props} /> */}
      </Fragment>
    );
  }
}

export default QuotationSentOwnerBtns;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationSentOwnerBtns.js